import { FC } from 'react'
import { Text } from '@/client/components'
import * as S from './styles'

export const BlogAuthor: FC<any> = ({ author_designation, author, author_image, social_media_link }) => (
  <S.BlogAuthorWrapper>
    <S.BlogAuthorSingle href={social_media_link}>
      <S.Photo>
        <img src={author_image['url']} />
      </S.Photo>
      <S.Details>
        <S.Name>
          <Text as='p' weight='normal' size='lg' style={{ margin: '0' }}>
            {author}
          </Text>
        </S.Name>
        <S.Designation>
          <Text as='p' weight='bold' size='lg' style={{ margin: '0' }}>
            {author_designation}
          </Text>
        </S.Designation>
      </S.Details>
    </S.BlogAuthorSingle>
  </S.BlogAuthorWrapper>
)
